var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKnightBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 4C27.5 5 33.5 12 33 33H10C10 24 20 26.5 18 12",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17 4C27.5 5 33.5 12 33 33H10C10 24 20 26.5 18 12",
    stroke: "#AAAAAA",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 12C19.38 14.91 13.45 19.37 11 21C8 23 8.18 25.34 6 25C4.958 24.06 7.41 21.96 6 22C5 22 6.19 23.23 5 24C4 24 0.997002 25 1 20C1 18 7 8 7 8C7 8 8.89 6.1 9 4.5C8.27 3.506 8.5 2.5 8.5 1.5C9.5 0.5 11.5 4 11.5 4H13.5C13.5 4 14.28 2.008 16 1C17 1 17 4 17 4",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19 12C19.38 14.91 13.45 19.37 11 21C8 23 8.18 25.34 6 25C4.958 24.06 7.41 21.96 6 22C5 22 6.19 23.23 5 24C4 24 0.997002 25 1 20C1 18 7 8 7 8C7 8 8.89 6.1 9 4.5C8.27 3.506 8.5 2.5 8.5 1.5C9.5 0.5 11.5 4 11.5 4H13.5C13.5 4 14.28 2.008 16 1C17 1 17 4 17 4",
    stroke: "#AAAAAA",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.5 19.5C4.5 19.6326 4.44732 19.7598 4.35355 19.8536C4.25979 19.9473 4.13261 20 4 20C3.86739 20 3.74021 19.9473 3.64645 19.8536C3.55268 19.7598 3.5 19.6326 3.5 19.5C3.5 19.3674 3.55268 19.2402 3.64645 19.1464C3.74021 19.0527 3.86739 19 4 19C4.13261 19 4.25979 19.0527 4.35355 19.1464C4.44732 19.2402 4.5 19.3674 4.5 19.5Z",
    fill: "#AAAAAA",
    stroke: "#AAAAAA",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.93302 9.74993C9.7341 10.0944 9.49772 10.3985 9.27586 10.5952C9.05401 10.792 8.86486 10.8652 8.75002 10.7989C8.63518 10.7326 8.60406 10.5322 8.66351 10.2417C8.72296 9.95119 8.8681 9.59444 9.06702 9.24993C9.26593 8.90541 9.50231 8.60134 9.72417 8.40462C9.94602 8.20789 10.1352 8.13462 10.25 8.20093C10.3649 8.26723 10.396 8.46768 10.3365 8.75817C10.2771 9.04867 10.1319 9.40541 9.93302 9.74993Z",
    fill: "#AAAAAA",
    stroke: "#AAAAAA",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKnightBlack);
export default __webpack_public_path__ + "static/media/Knight Black.f855a1a3fa85c4867277478d5df3998b.svg";
export { ForwardRef as ReactComponent };